import { Component, Input, OnInit } from '@angular/core'

@Component({
	selector: 'app-b2b-products',
	templateUrl: './b2b-products.component.html',
	styleUrls: ['./b2b-products.component.scss'],
})
export class B2bProductsComponent implements OnInit {
	@Input() data: any[] = []
	@Input() lang: string = 'pt'

	slideConfig = {
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		infinite: false,
		speed: 300,
		slidesToShow: 1,
		mobileFirst: true,
		swipeToSlide: true,
		variableWidth: true,
		touchThreshold: 4,
	}

	constructor() {}

	ngOnInit(): void {}
}
